module.exports = __webpack_public_path__ + "img/bti.8e813098.png";